module.exports = __webpack_public_path__ + "static/media/technology.30fdcefa.jpg";